module.exports = __webpack_public_path__ + "img/spot3.1bbb5420.svg";